import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import TrafficSignsMessagesModel from './TrafficSignsMessagesModel';
import UserModel from './UserModel';

import { Table, Badge, Divider, Row, Col, Statistic, Popconfirm, message } from 'antd';

class TrafficSignsMessagesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {}
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Seriové číslo',
      dataIndex: 'serialNumber',
      key: 'serialNumber',
      width: 170,
      sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
    }, {
      title: 'Popis',
      dataIndex: 'description',
      key: 'description',
      width: 500,
    }, {
      title: 'Zpráva',
      dataIndex: 'fullMessage',
      key: 'fullMessage',
    }, {
      title: 'Potvrzeno',
      dataIndex: 'ack',
      key: 'ack',
      width: 130,
      filters: [{
        text: 'ANO',
        value: true,
      }, {
        text: 'NE',
        value: false,
      }],
      filteredValue: filteredInfo.ack || null,
      onFilter: (value, record) => { return ((record.ack === value)) ? true : false },
      render: (text, record) => {
        if (record.ack === true) {
          return (
            <Badge
              status="success"
              text="ANO"
              title="Potvrzeno přijetí" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="NE"
              title="Nepotvrzeno" />
          );
        }
      }
    }, {
      title: 'Čas změny',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 200,
      sorter: (a, b) => dateSorter(a.updatedAt, b.updatedAt),
      render: (text, record) => {
        return moment(text).format('L LTS');
      }
    }, {
      title: 'Čas vytvoření',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.createdAt, b.createdAt),
      render: (text, record) => {
        return moment(text).format('L LTS');
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          onChange={this.handleChange} />
      </div>
    );
  }
}

export default TrafficSignsMessagesTable;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsMessagesTable.js